if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      // Checkboxes for agreement
      this.agreementBoxes = Array.from(document.querySelectorAll('.agree-accordion .ckBox, #notice .ckBox'));
      if (this.agreementBoxes.length) {
        this.agreementBoxes.forEach((box) => {
          box.addEventListener('change', this.checkCheckboxes.bind(this));
        });
        this.checkCheckboxes();
      }
    }

    checkCheckboxes() {
      this.submitButton.disabled = !this.agreementBoxes.every((box) => box.checked);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      /* 再塗装無料の対象商品は、オプションを同じリクエストに相乗りさせて一度に入れる */
      const repaintVariant = this.dataset.repaintOptionVariant;
      if (repaintVariant) {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items: [
            this.buildItemFromForm(formData),
            { id: Number(repaintVariant), quantity: this.formQuantity(formData), properties: { _repaint_auto: '1' } },
          ],
          sections: formData.get('sections'),
          sections_url: window.location.pathname,
        });
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          /* 複数商品で追加した場合は応答に key が無い。通知は先頭(=本体の商品)を見せる */
          if (!response.key && response.items && response.items.length) {
            response.key = response.items[0].key;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    formQuantity(formData) {
      const quantity = parseInt(formData.get('quantity'), 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    buildItemFromForm(formData) {
      const item = { id: Number(formData.get('id')), quantity: this.formQuantity(formData) };
      const properties = {};
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
